/*
  candywrap-bundle.js
  "Alle smaken" bundel in de quick shop en op de productpagina.
  - leest het data element .cw-bundle-all (snippets/cw-bundle-all.liquid)
  - haalt live de smaken van hetzelfde merk op uit de collectie json (alleen beschikbaar)
  - bouwt een alles of niets kaart onder de aantal trappen
  - in bundelmodus zet de toevoegknop alle smaken in een keer in het mandje
  - verstopt de losse hoeveelheid stepper achter "ander aantal"
*/
(function () {
  if (window.__cwBundleAllInit) return;
  window.__cwBundleAllInit = true;

  var lang = (document.documentElement.lang || '').toLowerCase();
  var isFR = lang.indexOf('fr') === 0;
  var isDE = lang.indexOf('de') === 0;
  var T = {
    label: isFR ? 'Ou prenez tous les parfums :' : isDE ? 'Oder alle Sorten:' : 'Of pak alle smaken:',
    all: isFR ? 'Tous les %n parfums' : isDE ? 'Alle %n Sorten' : 'Alle %n smaken',
    some: isFR ? 'Mix de %n parfums' : isDE ? '%n Sorten Mix' : 'Mix van %n smaken',
    one_each: isFR ? '1 de chaque, en un clic' : isDE ? '1 von jeder, mit einem Klick' : '1 van elke smaak, in één klik',
    discount: isFR ? '-%p %' : isDE ? '%p% Rabatt' : '%p% korting',
    discount_upto: isFR ? 'jusqu\'à -%p %' : isDE ? 'bis %p% Rabatt' : 'tot %p% korting',
    add: isFR ? 'Ajouter' : isDE ? 'Hinzufügen' : 'Toevoegen',
    flavours: isFR ? 'parfums' : isDE ? 'Sorten' : 'smaken',
    other: isFR ? 'autre quantité' : isDE ? 'andere Menge' : 'ander aantal',
    added: isFR ? 'Ajouté !' : isDE ? 'Hinzugefügt!' : 'Toegevoegd!',
    gone_some: isFR ? '%s vient de partir, tu reçois les %n autres.' : isDE ? '%s ist gerade ausverkauft, du bekommst die anderen %n.' : '%s is net op, je krijgt de andere %n.',
    gone_all: isFR ? 'Trop de parfums viennent de partir (%s), le lot n\'est plus disponible.' : isDE ? 'Zu viele Sorten sind gerade ausverkauft (%s), das Set ist nicht mehr verfügbar.' : 'Te veel smaken zijn net op (%s), de bundel is niet meer beschikbaar.'
  };

  var cache = {};

  function money(cents) {
    var e = Math.floor(cents / 100);
    var c = String(cents % 100).padStart(2, '0');
    return e + ',' + c;
  }

  function fetchCollection(handle, fresh) {
    var key = 'cwBundle:' + handle;
    if (fresh) { delete cache[key]; }
    if (cache[key]) return cache[key];
    if (!fresh) try {
      var raw = sessionStorage.getItem(key);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (Date.now() - parsed.t < 5 * 60 * 1000) {
          cache[key] = Promise.resolve(parsed.p);
          return cache[key];
        }
      }
    } catch (e) { /* geen storage, dan gewoon ophalen */ }

    cache[key] = (async function () {
      var all = [];
      for (var page = 1; page <= 4; page += 1) {
        var res = await fetch('/collections/' + handle + '/products.json?limit=250&page=' + page);
        if (!res.ok) break;
        var data = await res.json();
        var list = data.products || [];
        all = all.concat(list);
        if (list.length < 250) break;
      }
      var slim = all.map(function (p) {
        var v = p.variants && p.variants[0];
        return {
          handle: p.handle,
          title: p.title,
          vendor: p.vendor || '',
          type: p.product_type || '',
          variants: (p.variants || []).length,
          available: !!(v && v.available),
          variantId: v ? v.id : null,
          price: v ? Math.round(parseFloat(v.price) * 100) : 0,
          image: p.images && p.images[0] ? p.images[0].src : ''
        };
      });
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), p: slim })); } catch (e) { /* niks */ }
      return slim;
    })();
    return cache[key];
  }

  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('?') > -1) return src + '&width=' + w;
    return src + '?width=' + w;
  }

  function shortName(title, brand) {
    var t = title.replace(/^\*[^*]*\*\s*/, '').replace(/^freeze dried\s+/i, '');
    if (brand) {
      var words = brand.split(/\s+/).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
      var re = new RegExp('^' + words[0] + words.slice(1).map(function (w) { return '(\\s+' + w + ')?'; }).join('') + '\\s*:?\\s*', 'i');
      t = t.replace(re, '');
    }
    t = t.replace(/\s*\(\d+\s*(ml|g|gr)\)\s*$/i, '');
    return t.trim() || title;
  }

  function parseTiers(str) {
    return (str || '').split(',').map(function (s) {
      var p = s.split(':');
      return { qty: parseInt(p[0], 10), pct: parseInt(p[1], 10) || 0 };
    }).filter(function (t) { return t.qty > 0; }).sort(function (a, b) { return a.qty - b.qty; });
  }

  function pctFor(tiers, n) {
    var pct = 0;
    tiers.forEach(function (t) { if (n >= t.qty) pct = t.pct; });
    return pct;
  }

  /* complete sets (23 okt): staat de setkorting aan (candywrap.staffel_ui.actief, of previewthema), dan is de set uit n8n de bron */
  function cwSetUi() { if (window.__cwSetUi) return window.__cwSetUi; var el = document.querySelector('[data-cw-set-ui]'); if (!el) return null; try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; } }
  function cwSetOn() { var u = cwSetUi(); return !!(u && u.sets && u.sets.length && (u.actief === true || (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main'))); }
  function cwVid(g) { return String(g || '').split('/').pop(); }
  /* de set met de meeste overlap met deze variant ids (object met id: 1) */
  function cwMatchSet(ids) { var u = cwSetUi(); if (!cwSetOn() || !u) return null; var best = null, bo = 0; u.sets.forEach(function (s) { var o = 0; (s.items || []).forEach(function (it) { if (ids[cwVid(it.v)]) o++; }); if (o > bo) { bo = o; best = s; } }); return best; }
  // Staat de setkorting aan en hoort dit merk bij een set, dan zijn de smaken van de set de bron (zodat de knop precies de set toevoegt).
  // Het product zelf blijft er altijd bij, ook als het niet in de set zit. Smaken die net uitverkocht zijn vallen eruit.
  function applySet(el, items, products) {
    var ids = {}; items.forEach(function (p) { ids[String(p.variantId)] = 1; });
    var own = el.dataset.variantId || ''; if (own) ids[own] = 1;
    var st = cwMatchSet(ids); if (!st) return items;
    var byId = {};
    (products || []).forEach(function (p) { if (p.variantId) byId[String(p.variantId)] = p; });
    items.forEach(function (p) { byId[String(p.variantId)] = p; });
    var out = [];
    (st.items || []).forEach(function (it) {
      var id = cwVid(it.v), p = byId[id];
      if (p && !p.available) return;
      var o = p ? Object.assign({}, p) : { handle: it.h || '', title: it.t || '', vendor: '', type: '', variants: 1, available: true, variantId: parseInt(id, 10), price: Math.round(parseFloat(it.p) * 100) || 0, image: it.i || '' };
      o.setPct = Number(st.pct) || 0;
      out.push(o);
    });
    if (own && !out.some(function (p) { return String(p.variantId) === own; })) {
      var me = byId[own] || { handle: el.dataset.handle || '', title: el.dataset.title || '', vendor: el.dataset.vendor || '', type: el.dataset.productType || '', variants: 1, available: true, variantId: parseInt(own, 10), price: parseInt(el.dataset.price, 10) || 0, image: el.dataset.image || '' };
      out.push(Object.assign({}, me, { setPct: 0 }));
    }
    out.sort(function (a, b) { if (String(a.variantId) === own) return -1; if (String(b.variantId) === own) return 1; return a.title.localeCompare(b.title); });
    el.dataset.capped = '';
    el.dataset.setId = st.id || '';
    return out;
  }

  function normVendor(v) {
    return (v || '').toLowerCase().replace(/\.nl$/, '').trim();
  }

  // merk van een product: de vendor, tenzij die een huismerk is (candywrap),
  // dan het eerste bekende merk dat als woord in de titel voorkomt
  function brandOf(p, houseVendors, knownBrands) {
    var v = normVendor(p.vendor);
    if (v && houseVendors.indexOf(v) === -1) return v;
    var t = ' ' + (p.title || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ') + ' ';
    for (var i = 0; i < knownBrands.length; i += 1) {
      if (t.indexOf(' ' + knownBrands[i] + ' ') > -1) return knownBrands[i];
    }
    // tweede kans: alleen het eerste woord van het merk (monster, skittles, bomba), mits lang genoeg
    for (var j = 0; j < knownBrands.length; j += 1) {
      var first = knownBrands[j].split(' ')[0];
      if (first.length >= 5 && t.indexOf(' ' + first + ' ') > -1) return knownBrands[j];
    }
    return '';
  }

  function pickSiblings(el, products) {
    var houseVendors = (el.dataset.houseVendors || '').split(',').map(normVendor).filter(Boolean);
    var exTypes = (el.dataset.excludeTypes || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var exWords = (el.dataset.excludeWords || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var basePrice = parseInt(el.dataset.price, 10) || 0;
    var factor = parseFloat(el.dataset.maxPriceFactor) || 3;
    var max = parseInt(el.dataset.max, 10) || 12;
    var current = el.dataset.handle;

    // bekende merken = alle niet huismerk vendors in de collectie, langste naam eerst
    var known = {};
    products.forEach(function (p) {
      var v = normVendor(p.vendor);
      if (v && houseVendors.indexOf(v) === -1) known[v.replace(/[^a-z0-9]+/g, ' ').trim()] = true;
    });
    var knownBrands = Object.keys(known).sort(function (a, b) { return b.length - a.length; });

    var me = { vendor: el.dataset.vendor, title: el.dataset.title || '' };
    var brand = brandOf(me, houseVendors, knownBrands);
    if (!brand) return [];
    var brandKey = brand.replace(/[^a-z0-9]+/g, ' ').trim();

    var list = products.filter(function (p) {
      var b = brandOf(p, houseVendors, knownBrands);
      if (!b || b.replace(/[^a-z0-9]+/g, ' ').trim() !== brandKey) return false;
      if (!p.available || !p.variantId) return false;
      if (p.variants > 1) return false;
      if (exTypes.indexOf(p.type.toLowerCase()) > -1) return false;
      var t = (p.title + ' ' + p.handle.replace(/-/g, ' ')).toLowerCase();
      for (var i = 0; i < exWords.length; i += 1) if (t.indexOf(exWords[i]) > -1) return false;
      if (basePrice > 0 && p.price > basePrice * factor) return false;
      return true;
    });

    // huidig product eerst, daarna op naam
    list.sort(function (a, b) {
      if (a.handle === current) return -1;
      if (b.handle === current) return 1;
      return a.title.localeCompare(b.title);
    });
    el.dataset.brand = brand;
    el.dataset.capped = list.length > max ? 'true' : '';
    return list.slice(0, max);
  }

  function scopeOf(el) {
    return el.closest('quick-add-drawer') || el.closest('.product-info') || document;
  }

  function render(el, items) {
    var tiers = parseTiers(el.dataset.tiers);
    var vendor = el.dataset.brand || el.dataset.vendor || '';
    var n = items.length;
    // per smaak de hoogste van staffel (aantal) en setkorting (alleen smaken in de set), zoals de kortingsfunctie rekent
    var tier = pctFor(tiers, n), setPct = 0, allSet = true;
    items.forEach(function (p) { if (p.setPct) { if (p.setPct > setPct) setPct = p.setPct; } else allSet = false; });
    var pct = (allSet && setPct > tier) ? setPct : tier;
    var mixed = !allSet && setPct > tier;
    var savingLabel = mixed ? T.discount_upto.replace('%p', setPct) : T.discount.replace('%p', pct);
    var total = 0;
    var discounted = 0;
    items.forEach(function (p) {
      var pp = Math.max(tier, p.setPct || 0);
      total += p.price;
      discounted += p.price - Math.floor(p.price * pp / 100);
    });

    var collage = items.slice(0, 4).map(function (p) {
      return '<span class="cw-bundle-all__cell"><img src="' + imgUrl(p.image, 160) + '" alt="" loading="lazy"></span>';
    }).join('');
    var names = items.map(function (p) { return shortName(p.title, vendor); }).join(', ');

    el.innerHTML =
      '<p class="cw-qty-tiers__label cw-bundle-all__label">' + T.label + '</p>' +
      '<button type="button" class="cw-bundle-all__card" aria-pressed="false">' +
        '<span class="cw-bundle-all__collage cw-bundle-all__collage--' + Math.min(n, 4) + '">' + collage +
          (n > 4 ? '<span class="cw-bundle-all__more">+' + (n - 4) + '</span>' : '') +
        '</span>' +
        '<span class="cw-bundle-all__info">' +
          '<span class="cw-bundle-all__title">' + (el.dataset.capped ? T.some : T.all).replace('%n', n) + '</span>' +
          '<span class="cw-bundle-all__sub">' + T.one_each + '</span>' +
          '<span class="cw-bundle-all__names">' + names + '</span>' +
          '<span class="cw-bundle-all__prices">' +
            (discounted < total ? '<s>' + money(total) + '</s>' : '') +
            '<b>' + money(discounted) + '</b>' +
          '</span>' +
        '</span>' +
        (discounted < total ? '<span class="cw-bundle-all__saving">' + savingLabel + '</span>' : '') +
        '<span class="cw-bundle-all__check" aria-hidden="true"></span>' +
      '</button>' +
      '<p class="cw-bundle-all__notice" hidden></p>';

    el.dataset.items = JSON.stringify(items.map(function (p) { return { id: p.variantId, quantity: 1 }; }));
    el.dataset.names = items.map(function (p) { return p.variantId + '=' + shortName(p.title, vendor).replace(/[|=]/g, ' '); }).join('|');
    el.dataset.count = n;
    el.dataset.total = discounted;
    el.hidden = false;
  }

  function setBundleMode(el, on) {
    var scope = scopeOf(el);
    var card = el.querySelector('.cw-bundle-all__card');
    if (!card) return;
    card.setAttribute('aria-pressed', on ? 'true' : 'false');
    el.classList.toggle('cw-bundle-all--active', on);

    var overlayText = scope.querySelector('.cw-atc-overlay__text');
    var btn = scope.querySelector('product-form button[name="add"]');

    if (on) {
      // trappen uit, stepper op 1
      scope.querySelectorAll('.cw-qty-tier').forEach(function (t) {
        t.classList.remove('cw-qty-tier--selected');
        t.setAttribute('aria-pressed', 'false');
      });
      var savings = scope.querySelector('.js-cw-tier-savings');
      if (savings) { savings.classList.remove('is-visible'); savings.textContent = ''; }
      var qty = scope.querySelector('input[name="quantity"], .qty-input__input');
      if (qty && qty.value !== '1') { qty.value = 1; }

      scope.dataset.cwBundleMode = 'true';
      var label = T.add + ' • ' + el.dataset.count + ' ' + T.flavours + ' • ' + money(parseInt(el.dataset.total, 10));
      if (overlayText) {
        if (!overlayText.dataset.cwOrig) overlayText.dataset.cwOrig = overlayText.innerHTML;
        overlayText.textContent = label;
      }
      if (btn) {
        if (!btn.dataset.cwOrig) btn.dataset.cwOrig = btn.innerHTML;
        btn.textContent = label;
      }
    } else {
      delete scope.dataset.cwBundleMode;
      if (overlayText && overlayText.dataset.cwOrig) {
        overlayText.innerHTML = overlayText.dataset.cwOrig;
        delete overlayText.dataset.cwOrig;
      }
      if (btn && btn.dataset.cwOrig) {
        btn.innerHTML = btn.dataset.cwOrig;
        delete btn.dataset.cwOrig;
      }
      // eerste trap weer aan
      var first = scope.querySelector('.cw-qty-tier');
      var anySelected = scope.querySelector('.cw-qty-tier--selected');
      if (first && !anySelected) {
        first.classList.add('cw-qty-tier--selected');
        first.setAttribute('aria-pressed', 'true');
      }
    }
  }

  function exitBundleModeIn(scope) {
    var el = scope.querySelector('.cw-bundle-all--active');
    if (el) setBundleMode(el, false);
  }

  function showNotice(el, text) {
    var n = el.querySelector('.cw-bundle-all__notice');
    if (!n) return;
    n.textContent = text;
    n.hidden = !text;
  }

  async function addBundle(scope, el, form) {
    var items = JSON.parse(el.dataset.items || '[]');
    if (!items.length) return;
    var btn = scope.querySelector('product-form button[name="add"]') || form.querySelector('[name="add"]');
    var cartDrawer = document.querySelector('cart-drawer');
    var quickAdd = scope.tagName === 'QUICK-ADD-DRAWER' ? scope : null;
    var min = parseInt(el.dataset.min, 10) || 3;

    // verse voorraadcheck vlak voor het toevoegen: smaken die net op zijn vallen eruit
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-loading'); }
    try {
      var freshProducts = await fetchCollection(el.dataset.collection || 'verpakt-snoep', true);
      var freshItems = applySet(el, pickSiblings(el, freshProducts), freshProducts);
      var freshIds = freshItems.map(function (p) { return p.variantId; });
      var gone = items.filter(function (it) { return freshIds.indexOf(it.id) === -1; });
      if (gone.length) {
        var oldNames = {};
        (el.dataset.names || '').split('|').forEach(function (pair) {
          var kv = pair.split('=');
          if (kv[0]) oldNames[kv[0]] = kv[1] || '';
        });
        var goneNames = gone.map(function (it) { return oldNames[it.id] || ''; }).filter(Boolean).join(', ');
        render(el, freshItems);
        if (freshItems.length < min) {
          setBundleMode(el, false);
          el.hidden = true;
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
          var err0 = scope.querySelector('.js-form-error');
          if (err0) { err0.textContent = T.gone_all.replace('%s', goneNames); err0.hidden = false; }
          return;
        }
        setBundleMode(el, true);
        showNotice(el, T.gone_some.replace('%s', goneNames).replace('%n', freshItems.length));
        items = JSON.parse(el.dataset.items || '[]');
      }
    } catch (e) {
      console.log('cw bundle fresh check failed', e); // eslint-disable-line
    }

    var sections = 'cart-icon-bubble';
    if (cartDrawer) sections += ',' + cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
      });
      var data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || res.status);

      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) bubble.innerHTML = data.sections['cart-icon-bubble'];

      if (quickAdd && typeof quickAdd.addedToCart === 'function') quickAdd.addedToCart();

      setTimeout(function () {
        if (cartDrawer && data.sections) {
          var open = !quickAdd && ((window.theme && theme.settings && theme.settings.afterAtc === 'drawer_desktop' && theme.mediaMatches && theme.mediaMatches.md) || (window.theme && theme.settings && theme.settings.afterAtc === 'drawer'));
          cartDrawer.renderContents(data, open);
        } else if (cartDrawer) {
          cartDrawer.refreshCartDrawer();
        }
      }, 700);

      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { bundle: true, items: items } }));
    } catch (e) {
      console.log('cw bundle add failed', e); // eslint-disable-line
      var err = scope.querySelector('.js-form-error');
      if (err) { err.textContent = String(e.message || e); err.hidden = false; }
      if (cartDrawer) cartDrawer.refreshCartDrawer();
    } finally {
      if (btn) {
        btn.classList.add('is-success');
        btn.removeAttribute('aria-disabled');
        setTimeout(function () { btn.classList.remove('is-loading'); btn.classList.remove('is-success'); }, 1400);
      }
    }
  }

  // "ander aantal": stepper verstoppen als er trappen zijn
  function collapseQty(root) {
    root.querySelectorAll('.product-info__add-to-cart').forEach(function (wrap) {
      if (wrap.dataset.cwQtyInit) return;
      var block = wrap.closest('.product-info__block') || wrap.closest('quick-add-drawer') || wrap.closest('.product-info');
      var hasTiers = block && block.querySelector('.cw-qty-tiers');
      var qtyEl = wrap.querySelector('quantity-input');
      if (!hasTiers || !qtyEl) return;
      wrap.dataset.cwQtyInit = 'true';
      wrap.classList.add('cw-qty-collapsed');
      var link = document.createElement('button');
      link.type = 'button';
      link.className = 'cw-qty-other';
      link.textContent = T.other;
      link.addEventListener('click', function () {
        var open = wrap.classList.toggle('cw-qty-open');
        link.hidden = open;
        if (open) {
          var input = qtyEl.querySelector('input');
          if (input) input.focus();
        }
      });
      wrap.insertBefore(link, qtyEl);
    });
  }

  async function initEl(el) {
    if (el.dataset.cwInit) return;
    el.dataset.cwInit = 'true';
    var scope = scopeOf(el);
    if (scope.dataset) delete scope.dataset.cwBundleMode;
    var min = parseInt(el.dataset.min, 10) || 3;
    try {
      var products = await fetchCollection(el.dataset.collection || 'verpakt-snoep');
      var items = applySet(el, pickSiblings(el, products), products);
      if (items.length < min) { el.remove(); return; }
      render(el, items);
    } catch (e) {
      console.log('cw bundle init failed', e); // eslint-disable-line
      el.remove();
    }
  }

  // in bundelmodus mag candywrap-quickshop.js de knoptekst niet terugzetten
  function enforceLabel(scope) {
    if (!scope.dataset || scope.dataset.cwBundleMode !== 'true') return;
    var el = scope.querySelector('.cw-bundle-all--active');
    var btn = scope.querySelector('product-form button[name="add"]');
    if (!el || !btn) return;
    var label = T.add + ' • ' + el.dataset.count + ' ' + T.flavours + ' • ' + money(parseInt(el.dataset.total, 10));
    if (btn.textContent.trim() !== label) btn.textContent = label;
  }

  function scan(root) {
    root = root || document;
    root.querySelectorAll('.cw-bundle-all').forEach(initEl);
    collapseQty(root);
    if (root !== document) enforceLabel(root);
  }

  // kaart aan/uit
  document.addEventListener('click', function (evt) {
    var card = evt.target.closest('.cw-bundle-all__card');
    if (card) {
      var el = card.closest('.cw-bundle-all');
      var on = card.getAttribute('aria-pressed') !== 'true';
      setBundleMode(el, on);
      return;
    }
    // trap gekozen = bundel uit
    var tier = evt.target.closest('.cw-qty-tier');
    if (tier) exitBundleModeIn(scopeOf(tier));
  }, true);

  // stepper aangeraakt = bundel uit
  document.addEventListener('input', function (evt) {
    if (evt.target.matches('input[name="quantity"], .qty-input__input')) exitBundleModeIn(scopeOf(evt.target));
  }, true);

  // submit onderscheppen in bundelmodus (capture, dus voor product-form.js)
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form.matches || !form.matches('.js-product-form')) return;
    var scope = scopeOf(form);
    if (scope.dataset && scope.dataset.cwBundleMode === 'true') {
      var el = scope.querySelector('.cw-bundle-all--active');
      if (!el) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      addBundle(scope, el, form);
    }
  }, true);

  // quick shop laadt content async
  var drawer = document.querySelector('quick-add-drawer');
  if (drawer) {
    var obs = new MutationObserver(function () { scan(drawer); });
    obs.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
})();
